import { render, staticRenderFns } from "./ZoomFrame.vue?vue&type=template&id=c5c9e5ee&scoped=true&"
import script from "./ZoomFrame.vue?vue&type=script&lang=js&"
export * from "./ZoomFrame.vue?vue&type=script&lang=js&"
import style0 from "./ZoomFrame.vue?vue&type=style&index=0&id=c5c9e5ee&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c9e5ee",
  null
  
)

export default component.exports